import { Component, Input, OnInit } from '@angular/core';
import { IZCValidationTableResult } from 'src/app/interfaces/zc-validation-result.interface';

@Component({
    standalone: false,
    selector: 'zc-validation-result-table',
    templateUrl: './zc-validation-result-table.component.html',
    styleUrls: ['./zc-validation-result-table.component.scss']

})
export class ZcValidationResultTableComponent implements OnInit {
    @Input()
    data: IZCValidationTableResult[];

    constructor() {}

    ngOnInit(): void {}
}
